import languages from "../languages.json";
export default {
  mounted() {
    this.setLangs();
  },
  computed: {
    langs() {
      // watch change route query langs
      this.$route.query.langs;

      const localLangs = localStorage.getItem("langs");
      var langs = [];
      if (localLangs) {
        try {
          langs = JSON.parse(localLangs);
          langs = langs
            .map((lang) => ({ value: lang, label: languages[lang] }))
            .filter((lang) => !!lang.label);
        } catch (err) {
          console.error(err);
          localStorage.setItem("langs", []);
          langs = [];
        }
      }
      return langs;
    },
    lang: {
      get() {
        return this.$route.params.lang;
      },
      set(lang) {
        this.$router.push({ ...this.$route, params: { lang } });
        this.eventTracker.emitEvent("LANGUAGE_CHANGED", { lang });
      },
    },
    defaultLang() {
      return this.$route.params.defaultLang;
    },
  },
  methods: {
    setLangs() {
      var langs = this.$route.query.langs;
      if (langs) {
        console.debug("set languages to", langs);
        langs = Array.isArray(langs) ? langs : [langs];
        langs = langs.reduce(
          (array, lang) =>
            array
              .concat(lang.split(","), [])
              .filter((e, index, array) => index === array.indexOf(e)),
          []
        );
        localStorage.setItem("langs", JSON.stringify(langs));
      }
    },
  },
  watch: {
    lang: {
      handler(lang) {
        this.$store.dispatch("setLanguage", lang);
        document.documentElement.setAttribute("lang", lang);
      },
      immediate: true,
    },
    "$route.query.langs"() {
      this.setLangs();
    },
  },
};
